import axios from 'axios';
import config from '../../config/config';

const API_URI = config.API_URI;

export async function requestApi(path, method, params){
    const url = `${API_URI}${path}`;
    
    // Déterminer si c'est un FormData
    const isFormData = params instanceof FormData;
    
    const options = {
        method: method,
        url: url,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('user_token')}`,
        },
        data: params,
    };

    // Ne pas définir Content-Type pour FormData, axios le fait automatiquement
    if (!isFormData) {
        options.headers['Content-Type'] = 'application/json';
    }

    try {
        const response = await axios(options);
        return response;
    } catch (error) {
        console.error('Error making API request:', error);
        throw error;
    }
};

export default {
    create: async (productId, file) => {
        const formData = new FormData();
        formData.append('productId', productId);
        formData.append('image', file);
        
        const res = await requestApi('/products/images', 'POST', formData);
        return res;
    },
    delete: async (id) => {
        const res = await requestApi(`/products/images/${id}`, 'DELETE');
        return res;
    },
    findByProductId: async (productId) => {
        const res = await requestApi(`/products/images/product/${productId}`, 'GET');
        return res;
    },
    findById: async (id) => {
        const res = await requestApi(`/products/images/${id}`, 'GET');
        return res;
    }
};